export default __webpack_public_path__ + "static/MediaContentTwo-67dc547f957fcb5c88801e9ee4a9c03a.webp";